import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useRouteTrackerStore } from '@/store/useRouteTrackerStore'

export const RouteTracker = () => {
  const location = useLocation()
  const setRoute = useRouteTrackerStore((s) => s.setRoute)

  useEffect(() => {
    setRoute(location.pathname)
  }, [location.pathname, setRoute])

  return null
}
